import { render, staticRenderFns } from "./PublishPageViewer.vue?vue&type=template&id=33ac99d0"
import script from "./PublishPageViewer.vue?vue&type=script&lang=js"
export * from "./PublishPageViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports